import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useBookingDetail } from '../../hooks/booking/useBookingDetail';
import BookingDetail from './BookingDetail';
import { ROUTES } from '../../config/constants/routes';

const BookingDetailView = () => {
  const { id } = useParams<{ id: string }>();
  const bookingId = parseInt(id || '', 10);
  const { booking, isLoading, error } = useBookingDetail(bookingId);

  if (isNaN(bookingId)) {
    return <Navigate to={ROUTES.BOOKINGS} replace />;
  }

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '200px',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Navigate to={ROUTES.BOOKINGS} replace />;
  }

  return booking ? <BookingDetail booking={booking} /> : <CircularProgress />;
};

export default BookingDetailView;
